import { api } from '@/lib/api'
import type {
  AssetCheck,
  AssetCheckListResponse,
  CreateAssetCheckPayload,
} from '@/types/assetCheck'

export async function createAssetCheck(payload: CreateAssetCheckPayload): Promise<AssetCheck> {
  const { data } = await api.post<AssetCheck>('/asset-check/', payload)
  return data
}

export async function listAssetChecks(params?: {
  limit?: number
  offset?: number
  isin?: string
  verdict?: string
}): Promise<AssetCheckListResponse> {
  const { data } = await api.get<AssetCheckListResponse>('/asset-check/', { params })
  return data
}

export async function getAssetCheck(id: number): Promise<AssetCheck> {
  const { data } = await api.get<AssetCheck>(`/asset-check/${id}`)
  return data
}
